module.exports = __webpack_public_path__ + "static/projektowanie-opakowan-ergonomia-961c2cee1b2ec9f1bb39dd102323bfca.jpg";